import { Col, Row } from 'antd';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { useCallback, useEffect } from 'react';

import { NoLabelForm } from '../../components/forms/forms';
import { FormItemSelect } from '../../components/forms/selects';
import { useAccountOptions } from '../../components/domainSpecific/accountElements';
import { pxToNumber } from '../../utils/cssUtils';
import { cssVariables } from '../../styles/cssVariables';
import { StatementPaths } from '../../app/enums/StatementPaths';
import InvoiceContainer from '../invoice/InvoiceContainer';
import { useInvoiceStyles } from '../invoice/invoice.styles';

export function StatementSearch({ onClose }) {
  const { options: accountOptions } = useAccountOptions({
    filter: acc => !acc.partner,
  });
  const history = useHistory();
  const { styles } = useInvoiceStyles();

  const goToStatementResults = useCallback(
    account => {
      history.push(StatementPaths.RESULTS, { id: account });
    },
    [history]
  );

  useEffect(() => {
    if (accountOptions.length === 1) {
      goToStatementResults(accountOptions[0].value);
    }
  }, [accountOptions, goToStatementResults]);

  return (
    <InvoiceContainer titleId="account.statement" onClose={onClose}>
      <div className={styles.label}>
        <FormattedMessage id="invoice.account" />
      </div>

      <Row align="middle" gutter={pxToNumber(cssVariables.spaceNorm)}>
        <Col flex={1}>
          <NoLabelForm
            onValuesChange={val => {
              goToStatementResults(val?.account);
            }}
          >
            <FormItemSelect
              name="account"
              options={accountOptions}
              optionKey="number"
              labelId="invoice.label"
            />
          </NoLabelForm>
        </Col>
      </Row>
    </InvoiceContainer>
  );
}
